<template>
  <v-alert class="ma-3 d-flex justify-center align-center" outlined type="info">
    {{ $vuetify.lang.t(messageKey) }}
  </v-alert>
</template>

<script>
export default {
  props: {
    messageKey: {
      type: String,
      required: true,
    },
  },
};
</script>
